import { IAddKishu } from '../../models/forms/IAddUpdateKishu';
const initialKishuState: IAddKishu = {
  TenantId: -1,
  Kishu: '',
  KishuMark: 'please_select',
  Remarks: '',
};

export default initialKishuState;
